import { render, staticRenderFns } from "./accessForm.vue?vue&type=template&id=bdd69ba2&scoped=true&"
import script from "./accessForm.vue?vue&type=script&lang=js&"
export * from "./accessForm.vue?vue&type=script&lang=js&"
import style0 from "./accessForm.vue?vue&type=style&index=0&id=bdd69ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd69ba2",
  null
  
)

export default component.exports